import { LicenseInfo } from '@mui/x-data-grid-pro';

export const InitializeMUI = () => {
    LicenseInfo.setLicenseKey(
        '2691c8330c735fa6d912ffcbab8534cdTz01NDcwNixFPTE3MDA1NTAzMDk5MjEsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
    );
};
